import apiUrl from '../../../../constants';
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';

export default {
  name: 'bag-close-details',
  components: { VueElementLoading },
  props: ['KENGIC_API_KEY', 'hubid'],
  data() {
    return {
      isLoading: false,
      listmodal: false,
      isBagNumberError: 0,
      BagNumberError: '',
      bagNumber: '',
      modaldata: '',
      BagDetails: [],
      rowdata: ''
    }
  },
  computed: {},
  filters: {
    moment: function (date) {
      if (date == '' || date == null) {
        return '--'
      }
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  mounted() { },
  methods: {
    openlistmodal(data, d) {
      this.rowdata = d
      this.modaldata = data.ShippingIds
      this.listmodal = true
    },
    closelistmodal() {
      this.listmodal = false
    },
    getBagDetails() {
      if (this.bagNumber == '') {
        this.isBagNumberError = '1';
        this.BagNumberError = 'The Bag Number field is required.';
        return false;
      } else {
        this.isBagNumberError = '';
        this.BagNumberError = '';
      }
      this.isLoading = true
      this.input = ({})
      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + 'getBagInShipmentLiveDetailsForSorter?bagNumber=' + this.bagNumber.trim() + '&currentHubId=' + this.hubid,
        'data': this.input,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.BagDetails = result.data.ResponseData
            this.isLoading = false
          } else {
            this.$alertify.error(result.data.ReturnMessage)
            this.isLoading = false
          }
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    clearError() {
      if (this.bagNumber == '') {
        this.isBagNumberError = '1';
        this.BagNumberError = 'The Bag Number field is required.';
      } else {
        this.isBagNumberError = '';
        this.BagNumberError = '';
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/KengicSorter/BagInShipmentLiveResponse/BagInShipmentLiveResponse.js